var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-col',{staticClass:"s",attrs:{"span":+_vm.col}},[_c('div',{staticClass:"term"},[_vm._v(_vm._s(_vm.dataSource.label))]),_vm._v(" "),_c('div',{staticClass:"detail"},[(_vm.dataSource.text)?_c('span',[_vm._v(_vm._s(_vm.dataSource.text))]):_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a0022c5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/description/ZDisplay.vue
// module id = null
// module chunks = 